import { PRODUCT_MAP } from 'constants/products'

export const getProductName = (productId, content) => {
  const product = PRODUCT_MAP[productId]
  return content[`express_mode_view_restrictions_product_${product}`]
}
